export function toJS(data) {
  return data && typeof data.toJS === 'function' ? data.toJS() : data;
}